<template>
    <div class="page-wrap" v-if="!activeNav">
        <h2 class="title">{{ setTitle }}</h2>
        <div class="sub-title my-3">
            {{ setSubTitle }}
        </div>
        <div class="nav-box">
            <button class="primary" v-for="item in setButtons" :key="item.text" @click="handleClick(item)">{{ item.text
                }}</button>
        </div>
        <div class="function-wrap">
            <h3>功能介绍</h3>
            <div class="function-box">
                <div class="function-item" v-for="item in featureIntro" :key="item">
                    {{ item }}
                </div>
            </div>
        </div>
        <div class="bottom">
            <h4>常见问题：</h4>
            <div class="question-box">
                <div class="question-item" v-for="item in questions" :key="item.title">
                    <div class="title">{{ item.title }}</div>
                    <div class="content">{{ item.content }}</div>
                </div>
            </div>
            <template v-if="props.type === 'credibleReport'">
                <div>联系方式</div>
                <div>如有任何疑问，请联系我们的客服团队，我们将竭诚为您服务</div>
                <div>电话：029-81105420</div>
            </template>
        </div>
    </div>
    <div v-else>
        <credible-report :nav-text="activeNav && activeNav.text"
            v-if="type === 'credibleReport' && activeNav && activeNav.text" @cancel="handleClick()"></credible-report>
        <search-account :activeNav="activeNav" v-else-if="activeNav && activeNav.text === '用户账号查询'"
            @cancel="handleClick()"></search-account>
        <div v-else-if="activeNav && activeNav.text === '研学数据查询'" style="background-color: #08193d;">
            <!-- <iframe style="width: 100vw;height: 100vh;border:none;" src="https://xxld.100xsys.cn:1443/vpages/#/lowcode-grid/view/PG2403070001?srvApp=config"></iframe> -->
            <iframe style="width: 100vw;height: 100vh;border:none;"
                src="/vpages/#/lowcode-grid/view/PG2403070001?srvApp=config"></iframe>
            <button class="primary mb-2" @click="handleClick()">返回</button>
        </div>
        <!-- <button class="primary" @click="handleClick()">返回</button> -->
    </div>
</template>
<!-- 可信报告、数据查询平台引导页 -->
<script setup>
import { computed, ref } from 'vue'
import searchAccount from '@/components/searchAccount.vue'
import CredibleReport from "@/components/credibleReport.vue";
const props = defineProps({
    type: {
        type: String,
        default: 'credibleReport'
    }
})
const setTitle = computed(() => {
    return props.type === 'credibleReport' ? '可信报告查询平台' : '数据查询平台'
})
const setSubTitle = computed(() => {
    return props.type === 'credibleReport' ? '快速获取基地和机构的可信报告，助您做出明智决策' : '快速获取用户账号和研学数据'
})

const setButtons = computed(() => {
    if (props.type === 'credibleReport') {
        return [{
            text: "基地可信报告",
            href: "/credibleReport/base"
        }, {
            text: "机构可信报告",
            href: "/credibleReport/org"
        }]
    } else {
        return [{
            text: "用户账号查询",
            href: "/dataQuery/user"
        },
        {
            text: "研学数据查询",
            href: "/dataQuery/research"
        }]
    }
})

const featureIntro = computed(() => {
    if (props.type === 'credibleReport') {
        return [
            '快速查询：只需点击按钮，即可快速获取报告。',
            '详细报告：提供详细的可信度分析和信用评级。',
            '实时更新：报告内容实时更新，确保信息准确可靠。'
        ]
    } else {
        return [
            '快速查询：只需点击按钮，即可快速获取所需数据。',
            '实时更新：数据实时更新，确保信息准确可靠。'
        ]
    }
})
const questions = computed(() => {
    if (props.type === 'credibleReport') {
        return [
            {
                title: '如何获取报告？',
                content: '点击上方按钮，选择查询类型，即可查询。'
            },
            {
                title: '报告的可信度如何保证？',
                content: '我们的报告基于研学平台大数据统计分析自动生成，客观公正。'
            },
            {
                title: '报告内容包括哪些信息？',
                content: '报告内容包括基地/机构的经营实体信息、运营状态、公众责任险状态、研学服务\接待人数，研学课程\方案数量、全省热度排名等'
            }
        ]
    } else return [
        {
            title: '如何查询用户账号？',
            content: `点击“用户账号查询”按钮，输入单位全称，即可获取账号信息。`
        },
        {
            title: '研学数据的准确性如何保证？',
            content: `我们提供的数据是基于研学平台大数据统计分析自动生成，客观公正。`
        },
        {
            title: '研学数据内容包括哪些信息？',
            content: `数据内容包括全省研学活动数据的统计分析等。`
        }
    ]
})
const activeNav = ref('')
if(props.type==='searchAccount'){
    activeNav.value = {
        text: '用户账号查询'
    }
}
const handleClick = (item) => {
    activeNav.value = item
}
</script>

<style lang="scss" scoped>
button.primary {
    border: none;
    outline: none;
    background-color: #007bff;
    border-radius: 4px;
    color: #fff;
    padding: 10px 30px;
    margin-right: 10px;
}

.page-wrap {
    padding: 20px;

    .function-wrap {
        margin-top: 40px;

        .function-item {
            line-height: 35px;
        }
    }

    .bottom {
        width: 800px;
        margin: 40px auto;
        text-align: left;

        .question-box {
            .question-item {
                margin-bottom: 20px;
                padding: 10px 0 0;

                .title {
                    font-weight: bold;
                    line-height: 30px;
                }
            }
        }
    }
}
</style>